import React from "react";
import { trustBadges } from "../mock";
import { MapPin, ShieldCheck, Truck, Headphones } from "lucide-react";

const icons = { MapPin, ShieldCheck, Truck, Headphones };

export default function TrustBadges() {
  return (
    <section className="border-b border-navy/10 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-4 px-4 py-5 md:grid-cols-4 lg:px-8">
        {trustBadges.map((b) => {
          const Icon = icons[b.icon];
          return (
            <div key={b.title} className="flex items-center gap-3">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-sky text-navy">
                <Icon size={20} />
              </div>
              <div>
                <p className="text-[13px] font-bold leading-tight text-navy">{b.title}</p>
                <p className="text-xs text-navy/50">{b.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
